import { z } from 'zod/v4';

import { createEnumSchemaPreprocessor } from '../../../utils/create-enum-schema-preprocessor';

export const tunnelCategoryOptions = [
  'None',
  'TunnelBCDE',
  'TunnelCDE',
  'TunnelDE',
  'TunnelE',
] as const;

export const tunnelCategorySchema = createEnumSchemaPreprocessor(
  z.enum(tunnelCategoryOptions),
  tunnelCategoryOptions
);

export type TunnelCategory = z.infer<typeof tunnelCategorySchema>;
